import { ticketServiceApi } from "../../../../app/superAdmin/ticketServiceApi";
import { API_URL } from "../../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../../types";
import { AllReportResponse, GetAllReportParams } from "./report.types";

export const reportApi = ticketServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    // Queries
    getAllReports: builder.query<
      AllReportResponse,
      GetQueryArgsType<GetAllReportParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllReports,
        ...queryArgs,
      }),
      providesTags: ["GetAllReports"],
    }),

    generateReport: builder.mutation({
      query: ({ data, params }) => ({
        url: `${API_URL.generateReport}`,
        method: "POST",
        body: data,
        params,
      }),
      invalidatesTags: (result) => {
        return ["GetAllReports"];
      },
    }),
  }),
});

export const { useGetAllReportsQuery, useGenerateReportMutation } = reportApi;
